// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 9V3H1V9L23 9Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 11.0004V13.3895C22.1372 12.8269 21.1068 12.5 20 12.5C16.9624 12.5 14.5 14.9624 14.5 18C14.5 19.1068 14.8269 20.1372 15.3895 21L1 21V11.0004H23ZM9 17.0001V15.0001L4 15.0001L4 17.0001L9 17.0001Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 17V14H19V17H16V19H19V22H21V19H24V17H21Z"}}]};

const CreditcardAddFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'creditcard-add-filled',
    ref,
    icon: element,
  },
));

CreditcardAddFilledIcon.displayName = 'CreditcardAddFilledIcon';

export default CreditcardAddFilledIcon;
